import { FeatureToggleClientService } from 'feature-toggle-client';
export const usingCustomReportCountEndPoint = 'using-custom-report-count-endpoint';
export class ReportFeatures {
    static async isUsingCustomReportCountEndPoint() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(usingCustomReportCountEndPoint);
    }
}
